import config from 'config/socket/chat';
import { io } from 'socket.io-client';

const { webSocket } = config;

const socketMessages = io(webSocket.baseUrlWebSocketMessages, {
  autoConnect: false,
  reconnectionAttempts: 5,
  secure: true,
  transports: ['websocket', 'webtransport']
});

export default socketMessages;
